"use client"

import { useMutation, useQueryClient } from "@tanstack/react-query"
import {
  createCharacter,
  updateCharacter,
} from "@/features/characters/actions"
import { queryKeys } from "@/shared/lib/query-keys"

export function useCreateCharacter() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createCharacter,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.characters.all() })
    },
  })
}

export function useUpdateCharacter() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Parameters<typeof updateCharacter>[1] }) =>
      updateCharacter(id, data),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.characters.all() })
      queryClient.invalidateQueries({ queryKey: queryKeys.characters.detail(id) })
    },
  })
}
